import type { Locale } from "@/lib/i18n";
import { pl, type WNewsletterTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wNewsletterTranslations: Record<Locale, WNewsletterTranslations> = {
  pl,
  en,
  de,
};

export type { WNewsletterTranslations };
